import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { Icon } from 'Components/frameworks/icon/Icon';
export type PromoBannerProps = {
  className?: string;
  callToAction: string;
  closeLabel: string;
  description?: string;
  innerRef?: any;
  link: {
    target?: string;
    url: string;
  };
  onClick?: () => void;
  onClose: () => void;
  title: string;
};
export const PromoBanner = ({
  callToAction,
  className,
  closeLabel,
  description,
  innerRef,
  link,
  onClick,
  onClose,
  title,
}: PromoBannerProps) => {
  if (!title) {
    return null;
  }

  const hasLink = link?.url;
  const TagName = hasLink ? DynamicLink : 'div';
  const tagProps = hasLink ? { ...link, onClick } : {};
  return (
    <aside
      data-id="PromoBanner"
      className={classnames('relative flex h-50 items-center px-20 text-14 text-sienna', className)}
      ref={innerRef}
    >
      <div className="pointer-events-none absolute inset-0 bg-current opacity-5" />
      <TagName {...tagProps} className="flex w-full justify-center text-inherit">
        <div className="max-w-20 grow" />
        {/*
         the amount of shit we have to do to properly center stuff sometimes man;
         reasoning behind that is we have a div that'll grow up to 20px if it can
         but will gradually shrink when it runs out of space, in order to have a perfectly
         centered title when it's short, but to have it hug the edge of the container when it's long
        */}
        <div className="truncate">
          <span data-testid="PromoBanner-title" className="pe-10 font-bold">
            {title}
          </span>
          {hasLink && (
            <Icon
              className="me-10 sm:me-0 sm:hidden"
              hasRtl
              name={ICONS.ARROW_RIGHT}
              width=".7em"
            />
          )}
          {!!description && (
            <span className="hidden pe-10 md:inline" data-testid="PromoBanner-description">
              {description}
            </span>
          )}
        </div>
        {hasLink && (
          <span className="hidden shrink-0 pe-10 underline transition-color duration-250 ease-in md:inline">
            {callToAction}
          </span>
        )}
      </TagName>
      <button className="leading-0 text-inherit" onClick={onClose} type="button">
        <span className="sr-only">{closeLabel}</span>
        <Icon name={ICONS.CROSS} width="0.75rem" />
      </button>
    </aside>
  );
};
